import "babel-polyfill"
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import './assets/css/public.css';
Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
  if(to.meta.title) {
    document.title = to.meta.title
  }
  next();
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js